(function ($, Drupal) {
  'use strict';
  /**
   * Appointment Menu Formatter v1
   */

  Drupal.behaviors.apptMenuFormatterV1 = {
    attach: function (context) {
      var mContainer = $('.appt-book-page-header-menu'),
        apptNav = mContainer.find('.appointment-nav'),
        sectionPath = window.location.pathname,
        apptNavLink = apptNav.find('.appointment-nav__link'),
        apptNavHeight = apptNav.height(),
        win = $(window),
        jqBody = $('body'),
        siteContainer = jqBody.find('.site-container'),
        siteHeader = jqBody.find('.site-header'),
        siteBannerClosebtn = jqBody.find('.js-close-site-banner'),
        siteHeaderContainerB = $('.site-header__container').height(),
        privateBrowsing;

      if (site.client.isMobile) {
        try {
          sessionStorage.setItem('sessionTestVar', 1);
          sessionStorage.removeItem('sessionTestVar');
        } catch (err) {
          privateBrowsing = true;
        }
        apptNav.addClass('collapse');
        apptNavHeight = apptNav.height();
        mContainer.height(apptNavHeight);

        var apptNavHeader = apptNav.find('h3'),
          newArrowLink = $('<a />', {
            class: 'appointment-header-nav__link-arrow',
            href: '#',
            text: '^'
          });

        apptNavHeader.append(newArrowLink);

        if (newArrowLink.length > 0) {
          newArrowLink.click(function (e) {
            e.preventDefault();
            apptNav.toggleClass('collapse');
            apptNavHeight = apptNav.height();
            mContainer.height(apptNavHeight);
            $(window).trigger('apptNavCollapse');
          });
        }
      }

      siteBannerClosebtn.on('click', function () {
        setTimeout(function () {
          $(window).trigger('apptNavCollapse');
        }, 1000);
      });

      apptNavLink.each(function () {
        var linkPath = $(this).attr('href');

        if (linkPath == sectionPath) {
          $(this).addClass('active');
        }
        $(this).css('cursor', 'pointer').click(function (e) {
          if (linkPath == sectionPath) {
            e.preventDefault();
          }
        });
      });
    }
  };
})(jQuery, Drupal);
